/**
 * HBoxContainer parser: the shared BoxContainer parse (Control plus `alignment`).
 * `nativeSolver.ts` stacks the children, and the Control parser collects
 * `theme_override_constants/separation`.
 */
import { parseBoxContainer } from '../shared/boxContainer';
export function parseHBoxContainer(heading, properties) {
    return parseBoxContainer(heading, properties);
}
//# sourceMappingURL=parser.js.map